import CT from '@marketplace-ai/tags';

export const MALPRACTICE_TABS = [
  {
    name: 'Malpractice Insurance',
    current: true,
    cyTag: CT.malpractice.insuranceTab,
    state: '$_INSURANCES_TAB',
  },
  {
    name: 'Malpractice Claims',
    current: false,
    cyTag: CT.malpractice.claimsTab,
    state: '$_CLAIMS_TAB',
  },
];
